// Figures for people who haven't been customised yet, and the configurator's choices
// (organiser mockup o05). Colours are 0xRRGGBB so they feed makePerson() directly.
import type { Person } from './events'
import type { Figure } from './family'

/** The coat swatches in the configurator, in order. */
export const COATS = [0xff4f4f, 0xf5b21e, 0x1f8a3a, 0x43c6db, 0x2f7bff, 0x9b6bff, 0xff7ab6, 0x1b2a3a] as const
/** Hat and scarf swatches. */
export const ACCENTS = [0xff4f4f, 0xf5b21e, 0x1b2a3a, 0xffffff, 0x9b6bff, 0x1f8a3a, 0x43c6db] as const
export const HAT_KINDS = ['beanie', 'cap', 'hood', 'earmuffs', 'none'] as const
export const PROPS = ['board', 'skis', 'sled', 'camera', 'clipboard', 'none'] as const

/** The two figures the Who globe started with (stills W3-LN88-22). */
export const PLAYER_FIGURE: Figure = { coat: 0x1f8a3a, legs: 0x3d4a3a, hat: 0xf5b21e, hatKind: 'beanie', prop: 'board' }
export const ORGANISER_FIGURE: Figure = { coat: 0xf5b21e, legs: 0x1d3f6e, hat: 0x1b2a3a, hatKind: 'beanie', scarf: 0x1f8a3a, prop: 'clipboard' }

/** Starting looks for further children, so a new child doesn't match a sibling. */
const CHILD_DEFAULTS: Figure[] = [
  PLAYER_FIGURE,
  { coat: 0xff7ab6, legs: 0x5a3a6e, hat: 0x9b6bff, hatKind: 'beanie', scarf: 0xf5b21e, prop: 'skis' },
  { coat: 0x43c6db, legs: 0x1d3f6e, hat: 0xff4f4f, hatKind: 'beanie', prop: 'sled' },
  { coat: 0x9b6bff, legs: 0x1b2a3a, hat: 0xffffff, hatKind: 'earmuffs', prop: 'board' },
]

/** A person's figure: their own, or a default by kind and position among the children. */
export function figureFor(p: Pick<Person, 'id' | 'kind' | 'figure'>, people: readonly Pick<Person, 'id' | 'kind'>[] = []): Figure {
  if (p.figure) return p.figure
  if (p.kind !== 'child') return ORGANISER_FIGURE
  const i = Math.max(0, people.filter((x) => x.kind === 'child').findIndex((x) => x.id === p.id))
  return CHILD_DEFAULTS[i % CHILD_DEFAULTS.length] ?? PLAYER_FIGURE
}

/** The default look for the next new child. */
export function newChildFigure(childCount: number): Figure {
  return CHILD_DEFAULTS[childCount % CHILD_DEFAULTS.length] ?? PLAYER_FIGURE
}

export const hex = (c: number) => `#${c.toString(16).padStart(6, '0')}`
